export default __webpack_public_path__ + "static/media/Raleway-Italic-VariableFont_wght.89f64396.ttf";